export enum RefundStatus {
  RefundRequested = 1,
  Refunded = 2,
  PartialRefundRequested = 3,
  PartialRefunded = 4,
  All = 0,
}
